'use client'

import React from 'react'
import Image from 'next/image'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Tariffs: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.heading}>
					<Typography variant='h4' color='accent' className={styles.subtitle}>
					Тарифы
					</Typography>
					<Typography variant='h2' className={styles.title}>
					Стоимость работ
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<Table />
			</AnimatedSection>
		</section>
	)
}

const tableData = {
	columns: ['Вы получите', 'Почасовая оплата', 'Базовый', 'Расширенный '],

	rows: [
		{
			cells: [
				'Личный кабинет и система постановки задач',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg'
			]
		},
		{
			cells: [
				'Мониторинг работоспособности сайта<br><span class="tableCellDescription">Отслеживаем доступность сайта. При возникновении сбоев в Telegram приходят уведомления</span>',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg'
			]
		},
		{
			cells: [
				'Отслеживание сроков SSL-сертификата и домена<br><span class="tableCellDescription">Своевременно оповещаем о необходимости продлить жизненно важные сервисы для сайта</span>',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg',
				'/services/tariffs-done.svg'
			]
		},
		{
			cells: [
				'Количество часов технической поддержки',
				'/services/tariffs-close.svg',
				'10 часов в месяц',
				'30 часов в месяц'
			]
		},
		{
			cells: [
				'Стоимость',
				'<span class="price">5 500</span><span class="priceCurrency">₽/час</span>',
				'<span class="price">45 000</span><span class="priceCurrency">₽/мес.</span><br><span class="priceExtra">4 500 ₽/час сверх пакета</span>',
				'<span class="price">135 000</span><span class="priceCurrency">₽/мес.</span><br><span class="priceExtra">4 500 ₽/час сверх пакета</span>'
			]
		},
		{
			cells: [' ', 
				'btn', 
				'btn', 
				'btn'
			]
		}
	]
}

const Table: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
					<thead>
						<tr>
							{tableData.columns.map((col, i) => (
							<th key={i}>
								<Typography variant="p1" color="accent">
								{col}
								</Typography>
							</th>
							))}
						</tr>
					</thead>
				<tbody>
					{tableData.rows.map((row, rowIndex) => (
						<tr key={rowIndex}>
							{row.cells.map((cell, colIndex) => (
								<td key={colIndex}>
									{cell === 'btn' ? (
										<button 
											className={styles.btn}
											onClick={openConsultationModal}
										>
											<span className={styles.btnText}>Оставить заявку</span>
										</button>
									) : typeof cell === 'string' && cell.endsWith('.svg') ? (
										<img src={cell} alt="" className={styles.cellIcon} />
									  ) : typeof cell === 'string' ? (
										<div
										  className={styles.cellHtml}
										  dangerouslySetInnerHTML={{ __html: cell }}
										/>
									  ) : (
										cell
									  )}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}



Tariffs.displayName = 'Tariffs'

export default Tariffs

